import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";

// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
import styles from "../../../../services/ServicesSections.module.scss";
// core components





export default function SectionText() {
  const classes = styles;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section} id="start">
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={10} md={10}>
          <h2 className={classes.title}>
            {" "}
            Bringing a website back from the dead!!!
          </h2>
          <h3 id="summary">Summary</h3>

          <ul>
            <li>
              Even if you have no backup of your website and a blank slate, you
              can recover/rebuild your site!
            </li>
            <li>
              Most of your website files can be retrieved from{" "}
              <strong>Way Back Archive</strong> - especially the most important
              ones. In my case this was ~ 90% of all files
            </li>
            <li>
              For my site - all content pages could be retrieved. All of them.
            </li>
            <li>
              All feature images could be retrieved. In-post images were less
              likely to be retrieved though :-(
            </li>
            <li>
              Way Back becomes a great "clue set" to search your own local
              computers and cloud storage folders. Eg search for this file
              etc... helping you further uncover missing parts of your site or
              elements you need to build.
            </li>
            <li>It took me 8hrs total to rebuild everything.</li>
            <li>
              Every post/page was created (there were 9) from scratch - in
              reality copy/pasted from Way Back Archive
            </li>
            <li>
              The biggest time suck was marrying up fonts, templates, plugins
              and styling specific to the old blog and in wordpress. A bit of
              playing around here.
            </li>
            <li>
              Oh yeah and avoiding unscrupulous web hosting provider fees...
            </li>
          </ul>

          <h3 className={classes.title}>
            Background - www.scottsunderland.net
          </h3>
        </GridItem>
        <div style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <img
              src="/img/posts/2022-02-21-bring-website-back-from-the-dead/34.webp"
              alt="..."
              className={imgClasses}
            />

            <p>
              <br></br>
              <i>
                The old beauty... destined to exist only as a low res image on
                Way Back Archive...
              </i>
            </p>
          </GridItem>
        </div>
        <GridItem xs={12} sm={10} md={10}>
          <p>
            Back in 2012/13/14 I got into building my own websites and the most
            consequential one was{" "}
            <a href="https://www.scottsunderland.net" target="_blank">
              (New version) www.scottsunderland.net
            </a>
            . Now this was just a small website - it only consisted of 6 blog
            posts, an about me page and a contact me page. But its framework of
            wordpress/cornerstone/x-theme would become the basis of the first
            Tribalism website created in October 2016.
          </p>
          <p>
            My last post on the site - was when I announced the new{" "}
            <a href="https://www.tribalism.com.au" target="_blank">
              company site
            </a>{" "}
            and never posted on scottsunderland.net again.
          </p>
          <p>
            The main reason I never posted again - was because bluehost burned
            the website to the ground! I missed an annual payment - sent to an
            old email address that I dont check. There was no recourse from
            Bluehost - other than to delete everything and throw away the key.
          </p>
          <p>
            <strong>
              Obvious advice: make sure you have something saving up backups of
              your website. And try and make sure your service provider has an
              up to date contact for you. (Better still lock in your hosting for
              the long term not annually!)
            </strong>
          </p>
          <p>
            Some time at the end of 2017/early 2018 scottsunderland.net ceased
            to exist... a sad day for humanity.
          </p>

          <h3 className={classes.title}>
            The mission: Bring a website back from the dead.
          </h3>

          <p>
            Ok fine - but where do I start? There was no back up of the original
            site - only snapshots on Way Back Archive and we all know these are
            just random low res photos of websites... right??
          </p>
          <p>Right???</p>
          <p>
            Well no... Way Back Archive is actually awesome. Very, very Awesome.
            It stores a very large chunk of your websites files, from content,
            images to even plugins and other stuff used. See below:
          </p>
        </GridItem>
        <div style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <img
              src="/img/posts/2022-02-21-bring-website-back-from-the-dead/4.webp"
              alt="..."
              className={imgClasses}
            />

            <p>
              <br></br>
              <i>Some of the files of the old site on Way Back Archive</i>
            </p>
          </GridItem>
        </div>
        <GridItem xs={12} sm={10} md={10}>
          <p>
            I drooled at images like the above. This was practically a complete
            backup of my website!!! I had most of what I needed on Wayback. Now
            I just needed to get cracking!
          </p>

          <h3 className={classes.title}>The process</h3>

          <h4 className={classes.title}>Step 1: Get the domain name back</h4>

          <p>
            I decided to use{" "}
            <a href="https://domains.google/intl/en_au/" target="_blank">
              google domains
            </a>{" "}
            which is apparently still in Beta. Maybe they will be easier/better
            than GoDaddy etc etc. Well sort of not really... Thankfully{" "}
            <a href="http://www.scottsunderland.net" target="_blank">
              www.scottsunderland.net
            </a>{" "}
            was still available though 😀
          </p>
        </GridItem>
        <div style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <img
              src="/img/posts/2022-02-21-bring-website-back-from-the-dead/1.webp"
              alt="..."
              className={imgClasses}
            />

            <p>
              <br></br>
              <i>
                Picking up the domain name was easy on google domains (but its
                easy anywhere tbh!)
              </i>
            </p>
          </GridItem>
        </div>
        <GridItem xs={12} sm={10} md={10}>
          <p>
            I knew the website was built in wordpress originally (and if I
            didn't wayback clearly showed this) and was hoping for an easy set
            up through google domains. Well - it wasn't. Google in a lot of
            cases seems to just want one part of the process (the easy,
            lucrative part) and then just offload the rest. Thats the same here.
            Actually creating your site is offloaded to a partner site&gt; For
            Wordpress it is - you guessed it: Bluehost 🙄
          </p>
          <p>
            Other web frameworks are provided - eg Wix, Shopify but if you want
            wordpress you gotta go Bluehost... (unless you want to manually set
            everything up, which I was trying to avoid). I could have doen this
            but yeah... I had lots of work rebuilding everything to get to - so
            I just went with the this.
          </p>
        </GridItem>
        <div style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <img
              src="/img/posts/2022-02-21-bring-website-back-from-the-dead/5.webp"
              alt="..."
              className={imgClasses}
            />

            <p>
              <br></br>
              <i>Hello Bluehost my old friend</i>
            </p>
          </GridItem>
        </div>
        <GridItem xs={12} sm={10} md={10}>
          <h3 className={classes.title}>Step 2: Get web hosting</h3>

          <p>
            One of the biggest time sucks of the whole process followed. Google
            automatically sends you to the most expensive hosting option in
            Bluehost. In order to "get out" of this price you need to click on a
            million different pages and try to get to the bluehost site a
            million different ways through search etc... eventually I got a
            cheaper price... don't ask me how. I just kept clicking until I did
            - because I knew it was cheaper.
          </p>
        </GridItem>
        <div style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <img
              src="/img/posts/2022-02-21-bring-website-back-from-the-dead/all-bluehost-prices.webp"
              alt="..."
              className={imgClasses}
            />

            <p>
              <br></br>
              <i>
                Bluehost obfuscating the process and making it annoyingly hard
                to get the cheapest option
              </i>
            </p>
          </GridItem>
        </div>
        <GridItem xs={12} sm={10} md={10}>
          <p>
            After 1.5 hrs I ended up paying for 3 yrs hosting for $AUD6.94 a
            month. Bluehost like so many providers will offer very low rates for
            the first year eg $3.99 a month and then ramp that up to $21 a month
            for the following years. It really is a shady practice. People don't
            build a new website every day and are generally inexperienced at it.
            Even Experienced devs don't build a new site every day. Its a once a
            year max event. Adding in a byzantine and shady pricing process on
            top of this is exploitative in my opinion. I think authorities
            should look into these pricing processes!
          </p>
        </GridItem>
        <div style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <img
              src="/img/posts/2022-02-21-bring-website-back-from-the-dead/15.webp"
              alt="..."
              className={imgClasses}
            />

            <p>
              <br></br>
              <i>Finally got the cheapest option</i>
            </p>
          </GridItem>
        </div>
        <GridItem xs={12} sm={10} md={10}>
          <h3 className={classes.title}>
            Step 3: Rebuilding the site from Way Back Archive
          </h3>

          <h4 className={classes.title}>
            3.1 Collate list of content and image urls from way back
          </h4>

          <p>
            First step was to create a list of urls and available assets - which
            I did in google sheets - see below.
          </p>
        </GridItem>
        <div style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <img
              src="/img/posts/2022-02-21-bring-website-back-from-the-dead/31.webp"
              alt="..."
              className={imgClasses}
            />

            <p>
              <br></br>
              <i>List of urls and assets courtesy of Way Back Archive</i>
            </p>
          </GridItem>
        </div>
        <GridItem xs={12} sm={10} md={10}>
          <p>
            Now: is it possible to just copy all of these "files" into
            wordpress... yes??? See below - wayback saves pages as html - so
            theoretically you can "copy" everything back into a framework. But!
            we all know wordpress is a convoluted system of PHP and plugins,
            where the slightest old plugin can bring down the site. Given this
            was a small site - I just copied all the important bits out and
            rebuilt the pages one by one in wordpress - as posts and pages.
            Sounds terrible and would be for loads of pages but for each page it
            took around 10mins a page... not too bad.
          </p>
        </GridItem>
        <div style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <img
              src="/img/posts/2022-02-21-bring-website-back-from-the-dead/WayBack.webp"
              alt="..."
              className={imgClasses}
            />

            <p>
              <br></br>
              <i>Way back saves all your HTML</i>
            </p>
          </GridItem>
        </div>
        <GridItem xs={12} sm={10} md={10}>
          <h4 className={classes.title}>
            Step 3.2 Discover and Download them theme
          </h4>

          <p>
            It was pretty easy to see what theme was used on the old site using
            wayback. It has a full list of plugins and themes used! I could
            easily tell that it used the x-theme, which is part of the
            envato/cornerstone stack. At this stage I began to jog parts of my
            memory too - another benefit of Wayback. I searched my local drive
            for x-theme and sure enough found a local zip file copy.
            Unfortunately this was just a "base" install - nothing from my
            actual site. But still pretty useful! I uploaded the zip file to
            Wordpress.
          </p>
        </GridItem>
        <div style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <img
              src="/img/posts/2022-02-21-bring-website-back-from-the-dead/37.webp"
              alt="..."
              className={imgClasses}
            />

            <p>
              <br></br>
              <i>Uploading 2015 version of x-theme to wordpress</i>
            </p>
          </GridItem>
        </div>
        <GridItem xs={12} sm={10} md={10}>
          <p>
            It went about as well as could be expected. A few errors and
            what-not saying I needed to update to the latest versions which I
            did. I also tried to login to the cornerstone/x-theme website to see
            if the theme I had purchased was still current - it was! 😀
          </p>
        </GridItem>
        <div style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <img
              src="/img/posts/2022-02-21-bring-website-back-from-the-dead/41.webp"
              alt="..."
              className={imgClasses}
            />

            <p>
              <br></br>
              <i>Yeah so Scotty2Hotty used to be a thing apparently... 😬</i>
            </p>
          </GridItem>
        </div>
        <GridItem xs={12} sm={10} md={10}>
          <h4 className={classes.title}>Step 3.3 Piecing it all together</h4>

          <p>So I wanted everything to look like this:</p>
        </GridItem>
        <div style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <img
              src="/img/posts/2022-02-21-bring-website-back-from-the-dead/60.webp"
              alt="..."
              className={imgClasses}
            />

            <p>
              <br></br>
              <i>The old beauty...</i>
            </p>
          </GridItem>
        </div>
        <GridItem xs={12} sm={10} md={10}>
          <p>
            So I began the process, page by page. Starting with the homepage...
            and then quickly realising this was a bad idea. In wordpress you
            choose in settings whether to display your latest posts as the
            homepage or not... In my case I didnt need to create any homepage.
            See below.
          </p>
        </GridItem>
        <div style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <img
              src="/img/posts/2022-02-21-bring-website-back-from-the-dead/homepage.webp"
              alt="..."
              className={imgClasses}
            />

            <p>
              <br></br>
              <i>Ah yeah so that was a waste of time...</i>
            </p>
          </GridItem>
        </div>
        <GridItem xs={12} sm={10} md={10}>
          <p>
            Clearly a lot of the "process" is{" "}
            <strong>re-familiarising yourself with wordpress</strong>. Once you
            recall where everything goes/how it works - its all pretty
            straightforward.{" "}
            <strong>
              And the best way to re-familiarise yourself - is just diving in!
            </strong>
          </p>
          <p>
            From going through each of these issues and working with x-theme and
            way back I was able to trigger my memory of what stacks and
            themes/fonts were used. That was very helpful, but even if I'd had a
            complete mind blank or was working on a site I'd never seen before -
            I'd have been able to figure it out with trial and error. "Does this
            font look right? No. How about this... etc
          </p>
        </GridItem>
        <div style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <img
              src="/img/posts/2022-02-21-bring-website-back-from-the-dead/trials.webp"
              alt="..."
              className={imgClasses}
            />

            <p>
              <br></br>
              <i>
                Trials and Tribulations of the rebuild: 1. Addling links, 2.
                Losing in-post images, 3. enforcing https, 4. Pacifico font
                issues
              </i>
            </p>
          </GridItem>
        </div>
        <GridItem xs={12} sm={10} md={10}>
          <p>
            Once I'd rebuilt each post and page thats was it really. I
            reinstalled contact from 7 for the contact page and viola - it was
            ready to go. Check out both sites site by side - not perfect but
            very close and I'm very happy with the results. What do you think?
          </p>
        </GridItem>
        <div style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <img
              src="/img/posts/2022-02-21-bring-website-back-from-the-dead/both.webp"
              alt="..."
              className={imgClasses}
            />

            <p>
              <br></br>
              <i>Both websites side by side</i>
            </p>
          </GridItem>
        </div>
        <GridItem xs={12} sm={10} md={10}>
          <p>
            Thanks for reading and I hope this was helpful and motivating if you
            are trying to restore an old site.
          </p>
        </GridItem>
      </GridContainer>
    </div>
  );
}
